import * as React from "react";
const HaircutMale5 = ({ color }) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1080 1920">
		<title>{"coiffure m 5"}</title>
		<g id="Calque_1" data-name="Calque 1">
			<rect fill="none" width={1080} height={1920} />
		</g>
		<g id="coiffures_m" data-name="coiffures m">
			<path
				fill={color}
				stroke="black"
				strokeWidth="0.25"
				d="M641.08,116.91c5-6,3-11.07-2-15.1,4-4,0-24.16-15.1-20.14,0-9.06-10.36-14.33-17.11-12.08,0-4-8.06-10.06-14.1-5-2-3-7-4-9.06-1-1-4-8.05-7-12.08-4-1-6.05-8.05-6.05-8.05-6.05s-7,0-8.06,6.05c-4-3-11.07,0-12.08,4-2-3-7-2-9.06,1-6-5-14.1,1-14.1,5-6.75-2.25-17.11,3-17.11,12.08-15.1-4-19.13,16.11-15.1,20.14-5,4-7.05,9.06-2,15.1C475,124,486,135,486,135l5,62.42,6,9.07c0-15.11,1-26.18,7.05-35.24s4-34.23,4-34.23C521.27,127,563.56,127,563.56,127s42.28,0,55.37,10.07c0,0-2,25.17,4,34.23s7,20.13,7,35.24l6-9.07,5-62.42S652.15,124,641.08,116.91Z"
			/>
		</g>
	</svg>
);
export default HaircutMale5;
